import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  MinLengthValidator,
} from '@angular/forms';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { UserService } from 'app/store/services/user.service';
import { SessionService } from 'app/store/services/session.service';
import { IUserSessionData } from 'app/store/models/user.model';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openSnackbar } from '../../store/actions/page.action';

@Component({
  selector: 'app-set-variables',
  templateUrl: './set-variables.component.html',
  styleUrls: ['./set-variables.component.scss'],
})
export class SetVariablesComponent implements OnInit {
  sessionData: IUserSessionData;

  formGroup: FormGroup;
  formReady = false;

  updateButtonProperties: Button = {
    text: 'Update',
    color: ButtonColor.BLUE,
    size: ButtonSize.NORMAL,
    onClick: () => this.updateLabels(),
    style: 'filled',
  };

  error: { old?: string; new?: string; confirm?: string };

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    private readonly store$: Store<IReducers>
  ) {}

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.userService.getLabels().subscribe(response => {
          this.formGroup = new FormGroup({
            label1: new FormControl(response.label1.replace(/[{}]/g, ''), []),
            label2: new FormControl(response.label2.replace(/[{}]/g, ''), []),
            label3: new FormControl(response.label3.replace(/[{}]/g, ''), []),
          });
          this.formReady = true;
        });
      });
  }

  updateLabels() {
    const data = this.formGroup.getRawValue();
    this.userService.updateLabels(data).subscribe(() => {
      this.store$.dispatch(
        openSnackbar({
          snackbarData: {
            data: {
              type: 'success',
              message: 'Variables successfully changed!',
            },
            verticalPosition: 'bottom',
          },
        })
      );
    });
  }
}
